/** Reconstruct a CSV File from persisted text (e.g. after session restore). */
export function csvTextToFile(
  csvText: string,
  fileName = "import.csv",
): File {
  return new File([csvText], fileName, { type: "text/csv" });
}
